export default __webpack_public_path__ + "static/media/twitter-icon.e2994936.svg";